var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarbados(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#09207b",
    d: "M0 24V0h30v24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7cb4d",
    d: "M10 0h10v24H10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.33 8.45a4 4 0 0 0-2.24 1.15c-.07.08.36-.09.4-.1.31-.09-.1.45-.12.6-.33 1.03-.6 2.03-.71 3.22q0 .13-.05.14l-1.08-.16V9.47c.25 0 .65.06.87.14A7 7 0 0 1 15 7.02c-.33.91-.67 1.86-1.4 2.59.22-.08.62-.15.87-.14v3.83l-1.08.16q-.05-.01-.05-.14c-.1-1.2-.38-2.2-.7-3.23-.03-.14-.44-.68-.12-.58.03 0 .46.17.39.1a4 4 0 0 0-2.23-1.16q-.14-.02-.05.1a11 11 0 0 1 1.98 5.98c.42 0 1.44-.25 1.86-.25v2.7h1.06v-2.7c.42 0 1.44.25 1.86.25 0-2.34.9-4.31 1.98-5.98q.09-.12-.05-.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbados);
export default __webpack_public_path__ + "static/media/barbados.2287e7d6f8163838b85d668797c49d28.svg";
export { ForwardRef as ReactComponent };